export default {
  default: () => import("/unified-client/layouts/default.vue").then(m => m.default || m)
}